export default function(prefix =  'id') {
  return (prefix + String(performance.now()) + Math.random().toString(36)).substring(0, 18);
}
